import React, { useEffect, useState } from "react";
import {
  getGpaPercentAverages,
  getOverviewTexts,
  saveOverviewTexts,
} from "../../../lib/studentcourselessonreport";
import style from "./globalstudentgparigorsummary.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import { convertToFourPointScale } from "./utils/gradeUtils";
import { getColorClass ,getHeaderClass} from "./globalstudentgparigorsummary";

const levelClassMap = {
  Overall: style.apCell,
  AP: style.apCell,
  HR: style.hrCell,
  CC: style.ccCell,
  EA: style.eaCell,
  RG: style.rgCell,
  OT: style.otCell,
};

export default function GlobalStudentCourseLessonCalculatedGpaReport({
  studentId,
  isStudent = false,
}) {
  const [data, setData] = useState({});
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    loadData();
  }, [studentId]);

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const loadData = async () => {
    const res = await getGpaPercentAverages(studentId);
    const overviewRes = await getOverviewTexts(studentId);

    
    

    const dataMap = {};
    const deptSet = new Set();
    const levelSet = new Set();

    res.forEach((item) => {
      const { department, studentId, ...levelData } = item;
      deptSet.add(department);
      dataMap[department] = {};

      Object.entries(levelData).forEach(([level, value]) => {
        levelSet.add(level);
        dataMap[department][level] = convertToFourPointScale(value ?? 0);
      });
    });



    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });

  setData(dataMap);
  setDepartments([...deptSet]);
  // Custom sort order for levels
  const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => levelSet.has(lvl));
  setLevels(["Overall", ...sortedLevels]);
  setOverview(overviewMap);
  };

  const handleOverviewChange = (value) => {
    setOverview((prev) => ({ ...prev, reportCavgpa: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, {
      reportCavgpa: overview.reportCavgpa || "",
    });
    showToastMessage("Update successful!");
    loadData();
  };

  const getAvg = (value) =>
    value != null ? parseFloat(value).toFixed(2) : "0.0";

  const getColumnTotal = (level) =>
    departments
      .reduce((sum, dept) => sum + (parseFloat(data[dept]?.[level]) || 0), 0)
      .toFixed(2);

  return (
    <div className="card p-3">
      <div className="personal-info-head">
        <h4>Calculated GPA</h4>
        <ToastContainer
          style={{ top: "1rem", right: "1rem", position: "fixed" }}
          className="p-3"
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
              <button
                className="btn-close"
                onClick={() => setShowToast(false)}
              ></button>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      {/*}<h5>Average Calculated GPA (4.0)</h5>{*/}
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Department</th>
            {levels.map((lvl) => (
               <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {departments.map((dept, index) => (
            <tr key={dept}>
              <td>{dept}</td>
              {levels.map((lvl) => (
                <td
                  key={lvl}
                  //className={getColorClass(data[dept]?.[lvl] ?? 0, "gpa4")}
                  className={data[dept]?.[lvl] > 0 ? getHeaderClass(lvl): ""}
                >
                  {getAvg(data[dept]?.[lvl])}
                </td>
              ))}
              {index === 0 && (
                <td
                  rowSpan={departments.length + 1}
                  className={style.overviewCell}
                >
                  {!isStudent ? (
                    <textarea
                      rows={departments.length * 2}
                      className="form-control"
                      value={overview.reportCavgpa || ""}
                      onChange={(e) => handleOverviewChange(e.target.value)}
                    />
                  ) : (
                    <div className="bg-light border rounded p-2">
                      {overview.reportCavgpa}
                    </div>
                  )}
                </td>
              )}
            </tr>
          ))}
          <tr>
            <td>
              <strong>Average</strong>
            </td>
            {levels.map((lvl) => {
              // Get all values for this level, only include > 0
              

                let avg = 0;
               if(lvl === "Overall") {
                  const values = [];
                  departments.forEach((dept) => {
                    const val = parseFloat(data[dept]?.[lvl]) || 0;
                    if (val > 0) values.push(val);
                  });
                  avg = values.length > 0 ? (values.reduce((sum, val) => sum + val, 0) / values.length).toFixed(2) : '0.0';
               
                } else {
               const values = departments.map(dept => parseFloat(data[dept]?.[lvl]) || 0).filter(val => val > 0);
               avg = values.length > 0 ? (values.reduce((sum, val) => sum + val, 0) / values.length).toFixed(2) : '0.0';
              }

              return (
                <td key={lvl}
                  className={(avg > 0 ? getHeaderClass(lvl): "") + " fw-bold"}
                >
                  {avg}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
